import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React, { FunctionComponent } from "react";

export const TextIcon: FunctionComponent<SvgIconProps> = (props) => (
	<SvgIcon
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			d="M11 3C10.18 3 9.43999 3.5 9.13999 4.27L3.63999 18.27C3.11999 19.58 4.08999 21 5.49999 21H7.74999C8.58999 21 9.32999 20.5 9.61999 19.7L10.26 18H13.74L14.38 19.7C14.67 20.5 15.42 21 16.25 21H18.5C19.91 21 20.88 19.58 20.36 18.27L14.86 4.27C14.56 3.5 13.82 3 13 3M11 5H13L18.5 19H16.25L15.12 16H8.86999L7.74999 19H5.49999M12 7.67L9.61999 14H14.37L12 7.67Z"
			fill="#79818F"
		/>
	</SvgIcon>
);

export default TextIcon;
